import {
    ColoursObj,
    Icon,
    MainButton,
    Typography,
} from '@eventr/common-storybook'
import { Card, Stack } from '@mui/material'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../../../../i18n/i18next'
import { useBoundStore } from '../../../../state/bound.store'
import { useLanguageContext } from '../../../../state/languageState/languageContext'
interface IRequestEntryProps {
    id: string
    name?: string
    email: string
    message?: string
    itinerary?: string
    status: string
    createdAt: string
    itinName?: string
    itinId?: string
    onAccept: (id: string) => void
    onReject: (id: string) => void
}

export const RequestEntry = ({
    id,
    name,
    email,
    message,
    status,
    createdAt,
    itinerary,
    onAccept,
    onReject,
    itinName,
    itinId,
}: IRequestEntryProps) => {
    const { selectedOrg } = useBoundStore(
        useShallow((s) => {
            return { selectedOrg: s.selectedOrg }
        })
    )
    const { getLanguageISO639Code } = useLanguageContext()

    return (
        <Card
            sx={{
                padding: '16px',
                backgroundColor: ColoursObj.shades.shade4,
                width: '100%',
                boxSizing: 'border-box',
            }}
        >
            <Stack spacing={'16px'} width={'100%'}>
                <Stack
                    spacing={'4px'}
                    justifyContent="space-between"
                    alignItems={'flex-start'}
                >
                    {name && (
                        <Typography
                            id="requestingUserName"
                            variant="bodyBold"
                            color={ColoursObj.core.primary}
                        >
                            {name}
                        </Typography>
                    )}
                    <Typography
                        id="requestingUserEmail"
                        variant={name ? 'bodyRegular' : 'bodyBold'}
                        color={ColoursObj.core.primary}
                    >
                        {email}
                    </Typography>
                    <Typography
                        variant="bodySubtext"
                        color={ColoursObj.font.secondary}
                    >
                        {i18n.t('account.requesting-access-to')}
                    </Typography>
                    {selectedOrg && selectedOrg.friendlyName && (
                        <Stack
                            flexDirection="row"
                            alignItems="center"
                            gap="8px"
                        >
                            <Icon
                                name="Users"
                                iconColour={ColoursObj.font.secondary}
                                height="16px"
                                width="16px"
                            />
                            <Typography
                                id="requestedteamName"
                                variant="bodySubtext"
                                color={ColoursObj.font.secondary}
                            >
                                {selectedOrg.friendlyName}
                            </Typography>
                        </Stack>
                    )}
                    {itinName && (
                        <Stack
                            flexDirection="row"
                            alignItems="center"
                            gap="8px"
                        >
                            <Icon
                                name="Itinerary"
                                iconColour={ColoursObj.font.secondary}
                                height="16px"
                                width="16px"
                            />
                            <Typography
                                id="requestedItineraryName"
                                variant="bodySubtext"
                                color={ColoursObj.font.secondary}
                            >
                                {itinName}
                            </Typography>
                        </Stack>
                    )}
                    {itinerary && (
                        <Stack
                            flexDirection="row"
                            alignItems="center"
                            gap="8px"
                        >
                            <Icon
                                name="Itinerary"
                                iconColour={ColoursObj.font.secondary}
                                height="16px"
                                width="16px"
                            />
                            <Typography
                                variant="bodySubtext"
                                color={ColoursObj.font.secondary}
                            >
                                {itinerary}
                            </Typography>
                        </Stack>
                    )}
                </Stack>
                <Card
                    sx={{
                        padding: '16px',
                        background: ColoursObj.backgrounds.primary,
                    }}
                >
                    <Stack gap="8px">
                        <Typography
                            id="requestingAccessMessage"
                            variant="bodySubtext"
                            color={ColoursObj.font.primary}
                        >
                            {!message ? '' : message}
                        </Typography>
                        <Typography
                            id="requestedDate"
                            variant="bodySubtext"
                            color={ColoursObj.font.primary}
                        >
                            {'Requested on ' +
                                new Date(
                                    createdAt.replace(' ', 'T') /// replace out spaces for T so format still works for old ios 15 devices
                                ).toLocaleDateString(getLanguageISO639Code())}
                        </Typography>
                    </Stack>
                </Card>

                <Stack direction="row" gap="8px" justifyContent="center">
                    {status === 'pending' && (
                        <>
                            <MainButton
                                id="ignoreButton"
                                variant="secondary"
                                size="small"
                                style={{ width: '100%' }}
                                onClick={() => {
                                    onReject(id)
                                }}
                            >
                                {i18n.t('general.ignore')}
                            </MainButton>
                            <MainButton
                                id="approveButton"
                                size="small"
                                style={{ width: '100%' }}
                                onClick={() => {
                                    onAccept(id)
                                }}
                            >
                                {i18n.t('general.approve')}
                            </MainButton>
                        </>
                    )}
                    {status === 'approved' && (
                        <MainButton variant="secondary" size="small">
                            <Typography
                                variant="bodyRegular"
                                style={{ width: '100%' }}
                                color={ColoursObj.states.success}
                            >
                                {i18n.t('general.accepted')}
                            </Typography>
                        </MainButton>
                    )}
                </Stack>
            </Stack>
        </Card>
    )
}
